var _path, _path2, _path3, _path4, _path5, _polygon, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _polygon3, _circle2, _circle3, _circle4, _circle5, _path14, _circle6, _polygon4, _circle7, _path15, _circle8, _polygon5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 967.97244,
    height: 529,
    viewBox: "0 0 967.97244 529",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.44233,692.271c26.42252,19.03478,60.66413,19.99056,93.76235,17.65213,4.62174-.32609,9.21077-.70874,13.75729-1.12157.02746-.00712.06353-.00458.09143-.01167.2185-.0208.43744-.04161.6465-.054.93841-.08779,1.87724-.1755,2.80685-.26387l-.2196.419-.68925,1.30024c.2477-.43517.49521-.86129.74291-1.29646.07285-.13062.15451-.26067.22693-.39138,8.57426-14.92076,17.07842-30.38965,19.24765-47.4275,2.24221-17.68452-4.05929-37.70924-19.62367-46.40124a31.40808,31.40808,0,0,0-6.4449-2.69923c-.93085-.28285-1.8743-.51228-2.82845-.71534A33.66447,33.66447,0,0,0,216.76908,655.022c-13.19581-13.53109-10.73425-35.482-6.18233-53.82747,4.56073-18.34493,10.08188-38.7585.80579-55.236-5.15643-9.17155-14.2243-14.86189-24.40066-17.15421-.31218-.06731-.62393-.13454-.93675-.19277a49.13015,49.13015,0,0,0-35.29737,6.1847c-19.45809,12.26176-29.452,35.51036-32.69561,58.28426C112.8361,629.72786,124.40143,670.62755,154.44233,692.271Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#f1f1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.97318,633.5239a83.51853,83.51853,0,0,0,5.76411,23.53543A72.52018,72.52018,0,0,0,179.99707,675.451c9.49657,11.42369,22.05367,20.01238,35.691,25.73513a133.7282,133.7282,0,0,0,32.51657,8.737c4.62174-.32609,9.21077-.70874,13.75729-1.12157.02746-.00712.06353-.00458.09143-.01167.2185-.0208.43744-.04161.6465-.054.93841-.08779,1.87724-.1755,2.80685-.26387l-.2196.419-.68925,1.30024c.2477-.43517.49521-.86129.74291-1.29646.07285-.13062.15451-.26067.22693-.39138a73.92225,73.92225,0,0,1-20.71723-64.6648,74.55543,74.55543,0,0,1,13.89631-31.86317c-.93085-.28285-1.8743-.51228-2.82845-.71534a77.3,77.3,0,0,0-7.0511,11.67872,75.7417,75.7417,0,0,0-6.53473,47.11952,77.43753,77.43753,0,0,0,19.61965,38.62482c-.88275-.06222-1.77409-.1341-2.64633-.21369-16.52166-1.39976-33.00967-4.9516-47.995-12.22685a86.44054,86.44054,0,0,1-32.382-26.57c-9.07565-12.51653-13.07481-27.5721-13.7618-42.87405-.72844-16.38207,1.39716-33.05187,5.13582-48.9833a205.59724,205.59724,0,0,1,17.27595-47.05958,1.47818,1.47818,0,0,0-.58694-1.95143,1.25724,1.25724,0,0,0-.93675-.19277,1.09451,1.09451,0,0,0-.72256.619c-.94456,1.8435-1.87153,3.68824-2.76326,5.55359a207.93123,207.93123,0,0,0-16.2775,48.82276C163.00752,599.89618,161.25452,616.93624,162.97318,633.5239Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M498.01378,714.5h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#cbcbcb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M383.64443,445.9675,366.417,361.55189l-7.56774-62.3493-16.76577,10.846,2.31606,68.709,26.75976,71.18916a9.32773,9.32773,0,1,0,12.48513-3.97927Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#ffb7b7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.51709,452.49467l4.76864-86.02349-1.5795-62.787,22.16477,8.29264,3.70019,68.31545-16.123,74.32382a9.32774,9.32774,0,1,1-12.93108-2.12139Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#ffb7b7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "152.925 517.096 164.25 517.095 169.638 473.411 152.923 473.412 152.925 517.096",
    fill: "#ffb7b7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266.04945,698.89831l22.3041-.00091h.00091a14.2147,14.2147,0,0,1,14.21392,14.2137v.4619l-36.51825.00135Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "195.822 512.084 207.014 513.815 219.018 471.469 202.5 468.914 195.822 512.084",
    fill: "#ffb7b7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.54612,693.48825l22.042,3.40954.00089.00014a14.2147,14.2147,0,0,1,11.87341,16.22l-.07063.45646-36.089-5.58254Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M265.61172,689.55283l-.0587-.31681L224.55262,467.5608a83.73918,83.73918,0,0,1,7.39968-52.36494l24.81587-49.63139,74.0481,10.03176,8.73894,63.18874,31.14228,120.5417-.03084.09813-39.9,126.74124-26.14988,1.72,23.164-113.13449-42.41449-96.33649L288.358,687.8293Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M332.54,383.683l-.48871-.76574c-.08779-.13808-9.08238-13.68946-33.55867-4.64142-24.98636,9.23833-44.34706-8.60472-44.53981-8.7859l-.09585-.09042-5.65862-50.43534-6.68-40.94362,21.264-3.73059,10.45424-6.27209,41.57111-.74016,10.93945,8.604,17.96045,1.95729,1.64416,37.307-.00754.04065Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#1B75BB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M338.49789,318.75458v-31.945l5.05057-9.21731.20537-.00631a15.14058,15.14058,0,0,1,10.46072,4.75287c5.08,5.1615,7.38128,13.761,6.84,25.55936l-.01.21588Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#1B75BB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250.46647,315.28227,224.72452,312.193l-.02015-.29649c-.87824-12.8368,1.36239-22.36567,6.65951-28.32129,4.80754-5.40507,10.31616-5.73239,10.54834-5.74361l.14859-.007,6.96844,6.33482Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#1B75BB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M324.98425,254.40579h-67.7379a5.26145,5.26145,0,0,1-5.25552-5.25553V224.62447a39.12447,39.12447,0,0,1,78.24894,0v24.52579A5.26145,5.26145,0,0,1,324.98425,254.40579Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 292.68782,
    cy: 225.4797,
    r: 28.68469,
    transform: "translate(-161.56464 188.64661) rotate(-61.33685)",
    fill: "#ffb7b7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M319.95312,226.37631H282.08236a2.924,2.924,0,0,1-2.89721-2.55819l-.49042-3.92225a1.75171,1.75171,0,0,0-3.32576-.5235l-2.48264,5.31939a2.931,2.931,0,0,1-2.64572,1.68455H264.4881a2.91919,2.91919,0,0,1-2.90662-3.198l2.26821-23.69207a2.94218,2.94218,0,0,1,1.66859-2.378c17.34363-8.09656,34.93134-8.0863,52.275.0308a2.924,2.924,0,0,1,1.652,2.24112l3.3979,23.66128a2.91891,2.91891,0,0,1-2.89008,3.33488Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.719 265.859 266.305 264.445 327.767 202.982 446.875 202.982 506.97 141.647 624.539 141.647 683.855 81.869 959.972 81.869 959.972 83.869 684.688 83.869 625.372 143.647 507.81 143.647 447.715 204.982 328.596 204.982 267.719 265.859",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 508.97244,
    cy: 143,
    r: 37,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 684.97244,
    cy: 83,
    r: 10,
    fill: "#cbcbcb"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 957.97244,
    cy: 83,
    r: 10,
    fill: "#cbcbcb"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 821.97244,
    cy: 83,
    r: 10,
    fill: "#cbcbcb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M624.98622,366.5a38,38,0,1,1,38-38A38.04307,38.04307,0,0,1,624.98622,366.5Zm0-74a36,36,0,1,0,36,36A36.04061,36.04061,0,0,0,624.98622,292.5Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 508.97244,
    cy: 143,
    r: 26.43632,
    fill: "#1B75BB"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "506.453 154.16 498.541 143.986 503.142 140.407 506.889 145.224 519.545 131.863 523.777 135.873 506.453 154.16",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.97244,
    cy: 204,
    r: 37,
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M442.98622,427.5a38,38,0,1,1,38-38A38.04315,38.04315,0,0,1,442.98622,427.5Zm0-74a36,36,0,1,0,36,36A36.0407,36.0407,0,0,0,442.98622,353.5Z",
    transform: "translate(-116.01378 -185.5)",
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.97244,
    cy: 204,
    r: 26.43632,
    fill: "#1B75BB"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.453 215.16 316.541 204.986 321.142 201.407 324.889 206.224 337.545 192.863 341.777 196.873 324.453 215.16",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/inProgress.01ae689ff7add6eb76f2d369e5e79c5f.svg";
export { ForwardRef as ReactComponent };